var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { toMoney, toDateTime, toPorciento } from 'helpers/Format';
import TicketsReport from '../components/TicketsReport';
import history from '../../../helpers/History';
import { T } from '../../../helpers/i18n';
import TicketRenderModal from './TicketRenderModal';
import { twoDigits } from '../../../helpers/Utils';
import { PaymentMethod } from '../../../Models/TicketPayment';
let TicketSales = class TicketSales extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            showModalTicket: true
        };
        this.findUser = (lista, id) => {
            const result = lista.find(value => value.id === id);
            return result ? result.name : '';
        };
        this.handleOnSelectItem = (item) => {
            let value = item.numero;
            if (this.props.store.reports.selected === item.numero) {
                value = '';
            }
            this.setState({ showModalTicket: true });
            this.itemSelected = item;
            return;
            this.props.store.reports.setSelected(value);
            // console.log((item as any).id)
            if (this.props.store.reports.selected !== '')
                history.push(`/tickets/${item.id}`, item);
        };
        this.toggle = () => {
            this.setState({ showModalTicket: false });
        };
        this.onRefunded = (value) => {
            // console.log('value: ', value)
            this.props.store.reports.readTicketsUser(this.props.store.users.user.id);
        };
    }
    componentDidMount() {
        // console.log('TicketSales - componentDidMount')
        this.props.store.reports.readTicketsUser(this.props.store.users.user.id);
        this.props.store.users.read();
    }
    render() {
        // console.log('TicketSales - render()')
        const { showModalTicket } = this.state;
        const itemSelected = this.itemSelected;
        const { selected, invoicesLoaded } = this.props.store.reports;
        const headers = [
            /*'businessUnit',
            'operationLine',
            'stretch',*/
            'numero',
            /*'user',*/
            'datecheck',
            /*'datevalited',
            'terminal',
            'netAmount',
            'discount',
            'taxAmount',*/
            'total',
            'tipoPago'
        ];
        const items = this.props.store.reports.tickets;
        // console.log('TicketSales - render() - items.length: ', items.length)
        return (React.createElement(React.Fragment, null,
            React.createElement(TicketsReport, { selected: selected, onSelectItem: this.handleOnSelectItem, search: true, header: headers, items: items, 
                /*total={(tickets: Ticket[]) =>
                  tickets.reduce((sum, item) => item.total + sum, 0)}*/
                /*total={(tickets: Ticket[]) =>
                  tickets.reduce((sum, item) => {
                    if (item.daterefund) return sum
                    return item.total + sum
                  }, 0)}*/
                loading: !invoicesLoaded, keyExtractor: (ticket) => String(ticket.id), format: (tickets) => tickets.map(ticket => (Object.assign(Object.assign({}, ticket), { businessUnit: ticket.businessUnit, operationLine: ticket.operationLine, stretch: ticket.stretch, datecheck: toDateTime(ticket.datecheck), datevalited: !ticket.daterefund ? ticket.datevalited ? toDateTime(ticket.datevalited) : 'sin validar' : T('canceled'), discount: toPorciento(ticket.discount), netAmount: toMoney(ticket.netAmount), taxAmount: toMoney(ticket.taxAmount), 
                    /*taxBase: toMoney(ticket.taxBase),*/
                    total: toMoney(ticket.total), 
                    // user: ticket.user// this.findUser(this.props.store.users.users, ticket.user_id)
                    /*user: this.findUser(this.props.store.users.users, ticket.user_id)*/
                    user: ticket.username, tipoPago: ticket.totalDue && ticket.totalDue > 0 ?
                        T('pending') :
                        ticket.payments && ticket.payments.length > 0 ?
                            ticket.payments.reduce((previous, current, index, array) => {
                                if (array.length > 1 && current.method === PaymentMethod.Due) {
                                    return previous;
                                }
                                if (index < array.length - 1) {
                                    previous += T(current.method) + ', ';
                                }
                                else {
                                    previous += T(current.method);
                                }
                                return previous;
                            }, '') :
                            T(ticket.tipoPago) }))) }),
            showModalTicket && itemSelected && React.createElement(TicketRenderModal, { ticket: itemSelected, onToggle: this.toggle, onRefunded: this.onRefunded })));
    }
};
TicketSales = __decorate([
    inject('store'),
    observer
], TicketSales);
export const tramoHora = (dateBook, hours, minutes) => {
    if (dateBook) {
        const _hours = hours ? twoDigits(hours) : twoDigits(dateBook.getUTCHours());
        const _minutes = minutes ? twoDigits(minutes) : twoDigits(dateBook.getUTCMinutes());
        return `${_hours}:${_minutes}`;
    }
    return '';
};
export default TicketSales;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/TicketSales.tsx
// module id = 71
// module chunks = 0